module.exports = __webpack_public_path__ + "static/media/bars.51f8f52c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuBar/assets/bars.svg
// module id = 327
// module chunks = 0